import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { StatusMessageService } from '@core/services';
import { StatusMessageType } from '@shared/components/status-message-widget/status-message-widget.component';
import { catchError, throwError } from 'rxjs';

export const errorHandlerInterceptor: HttpInterceptorFn = (req, next) => {
  const toast = inject(StatusMessageService);

  return next(req).pipe(
    catchError((error) => {
      const errorDetails = error?.error?.detail ?? 'Unexpected error occurred.';
      toast.show(errorDetails, StatusMessageType.Error);
      return throwError(() => error);
    })
  );
};
